import * as yup from 'yup';

export const schemaLocationForm = yup.object().shape({
  addressEn: yup.string().required('District name is a required field'),
  locationName: yup.string().required('Building name is a required field').min(4, 'Building name must be at least 4 characters long.'),
  coordinatesLong: yup.string().required('Location is a required field.'),
  coordinatesLat: yup.string().required('Location is a required field'), 
});
